module.exports = "::ng-deep .modal-dialog {\n  max-width: 750px !important;\n}\n\nul {\n  padding-left: 20px;\n}"